export const SELF_SERVICE_DNR_FLOW_TYPES = {
  TRIAL: 'trial',
  SUBSCRIPTION: 'subscription',
};

export const SUBSCRIPTION_STATUS_CANCEL_RENEWAL = 'cancel_renewal';

// ZenAPI adds this cancelTrial reason only when the service is not one of the self-service trial services.
const SERVICE_NOT_TRIAL_ELIGIBLE_REASON = 'service_not_trial_eligible';

/**
 * Whether ZenAPI allows a self-service action on the subscription. Fails closed: a missing
 * customerActions object or action key means the action is not offered.
 *
 * @param {object} subscription Billing subscription record.
 * @param {'doNotRenew'|'undoDoNotRenew'|'cancelTrial'|'resumeTrial'} actionName ZenAPI customer action.
 * @returns {boolean} True only when ZenAPI explicitly allows the action.
 */
export function isCustomerActionAllowed(subscription, actionName) {
  return subscription?.customerActions?.[actionName]?.allowed === true;
}

/**
 * Whether resuming a trial uses the self-service restart route instead of the legacy modal.
 * resumeTrial.allowed only answers whether the action is shown, so routing keys off the
 * service eligibility reason ZenAPI reports for cancelTrial. Missing data falls back to the modal.
 *
 * @param {object} subscription Billing subscription record.
 * @returns {boolean} True when the trial should navigate to the restart route.
 */
export function shouldRouteTrialResume(subscription) {
  const cancelTrial = subscription?.customerActions?.cancelTrial;

  return (
    Boolean(subscription?.inTrial) &&
    Boolean(cancelTrial) &&
    !(cancelTrial.reasons ?? []).includes(SERVICE_NOT_TRIAL_ELIGIBLE_REASON)
  );
}
